import { AuthClient } from '@micro-frontend-react/employee-experience/lib/AuthClient';
import { TelemetryClient } from '@micro-frontend-react/employee-experience/lib/TelemetryClient';
import { HttpClient } from '@micro-frontend-react/employee-experience/lib/HttpClient';
import { Shell } from '@micro-frontend-react/employee-experience/lib/Shell';
import { withStore } from '@micro-frontend-react/employee-experience/lib/withStore';
import { StoreBuilder } from '@micro-frontend-react/employee-experience/lib/StoreBuilder';
import { ReducerRegistry } from '@micro-frontend-react/employee-experience/lib/ReducerRegistry';
import { LogLevel } from '@azure/msal-browser';
import { IAppState } from './App.types';

const telemetryClient = new TelemetryClient({
  instrumentationKey: __INSTRUMENTATION_KEY__,
  UTPConfig: {
    EnvironmentName: __IS_PRODUCTION__ ? 'Production' : 'Non-Production',
    ServiceOffering: 'Human Resources',
    ServiceLine: 'HR Services',
    Service: 'Offboarding',
    ComponentName: __APP_NAME__,
    ComponentId: __CLIENT_ID__,
  },
  defaultProperties: {
    appName: __APP_NAME__,
    appVersion: __COMMIT_HASH__,
  },
});
const authClient = new AuthClient(
  {
    auth: {
      clientId: __CLIENT_ID__,
      redirectUri: __BASE_URL__ || window.location.origin,
      authority: __B2C_AUTHORITY__,
      knownAuthorities: [__B2C_KNOWN_AUTHORITY__],
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
        loggerCallback: (level, message) => {
          if (level === LogLevel.Error) console.error(`[MSAL] ${message}`);
          else if (level === LogLevel.Warning) console.warn(`[MSAL] ${message}`);
        },
      },
    },
  },
  telemetryClient
);

const httpClient = new HttpClient(telemetryClient, authClient);
const graphClient = {
  getPhoto(id: string) {},
};
const reducerRegistry = new ReducerRegistry();
const appName = 'Offboarding';
const storeResult = new StoreBuilder<IAppState>(reducerRegistry, {
  dynamic: {},
})
  .configureLogger(__IS_DEVELOPMENT__)
  .configureSaga({ telemetryClient, authClient, httpClient, graphClient, appName })
  .configurePersistor({
    blacklist: ['dynamic'],
  })
  .build();

export const ShellWithStore = withStore(storeResult)(Shell);
